import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login/Login'
import Layout from '@/pages/home/Layout'
import Index from '@/pages/home/Index'
import Banner from '@/pages/banner/Banner'
import Banner_add from '@/pages/banner/Add'
import Popup from '@/pages/banner/Popup'
import Jg from '@/pages/jg/Jg'
import Jg_add from '@/pages/jg/Add'
import Privacy_policy from '@/pages/base/Privacy_policy'
import Goods from '@/pages/goods/Goods'
import GoodsEdit from '@/pages/goods/Edit'
import Goods_cate from '@/pages/goods/Cate'
import Goods_tag from '@/pages/goods/Tag'
import Goods_comment from '@/pages/goods/Comment'
import RecommendGoodsList from '@/pages/goods/RecommendGoodsList'
import RecommendGoodsAdd from '@/pages/goods/RecommendGoodsAdd'
import InspectionReportList from '@/pages/goods/InspectionReportList'
import BusinessQualification from '@/pages/goods/BusinessQualification'
import ServiceNote from '@/pages/goods/ServiceNote'
import User from '@/pages/user/User'
import UserDetail from '@/pages/user/UserDetail'
import WriteoffRecord from '@/pages/user/WriteoffRecord'
import Level from '@/pages/user/Level'
import LevelAdd from '@/pages/user/Add'
import Order from '@/pages/order/Order'
import OrderEntry from '@/pages/order/OrderEntry'
import Setting from '@/pages/setting/Setting'
import JourneySetting from '@/pages/setting/JourneySetting'
import Pickup from '@/pages/setting/Pickup'
import PickupAdd from '@/pages/setting/PickupAdd'
import Delivery from '@/pages/setting/Delivery'
import Role from '@/pages/setting/Role'
import RoleAdd from '@/pages/setting/RoleAdd'
import Manager from '@/pages/setting/Manager'
import ManagerAdd from '@/pages/setting/ManagerAdd'
import AfterSale from '@/pages/order/AfterSale'
import Finance from '@/pages/finance/Finance'
import Commission from '@/pages/commission/Commission'
import ReportForm from '@/pages/commission/ReportForm'
import CommissionMember from '@/pages/commission/Member'
import CommissionOrder from '@/pages/commission/CommissionOrder'
import LowerLevel from '@/pages/commission/LowerLevel'
import PromoteUsers from '@/pages/commission/PromoteUsers'
import DlApply from '@/pages/commission/DlApply'
import BranchOffice from '@/pages/commission/BranchOffice'
import AgencyChannel from '@/pages/commission/AgencyChannel'
import GiftCardManage from '@/pages/market/giftCard/GiftCardManage'
import GiftCardAdd from '@/pages/market/giftCard/GiftCardAdd'
import StockRecord from '@/pages/market/giftCard/StockRecord'
import CardGroup from '@/pages/market/giftCard/CardGroup'
import WatchCardGroup from '@/pages/market/giftCard/WatchCardGroup'
import CardEncryptionRecord from '@/pages/market/giftCard/CardEncryptionRecord'
import GiftCardOrder from '@/pages/market/giftCard/GiftCardOrder'
import GroupGoods from '@/pages/market/groupBuy/GroupGoods'
import GroupGoodsAdd from '@/pages/market/groupBuy/GroupGoodsAdd'
import GroupList from '@/pages/market/groupBuy/GroupList'
import RechargeAmount from '@/pages/market/balance/RechargeAmount'
import RechargeRecord from '@/pages/market/balance/RechargeRecord'
import RechargeConfig from '@/pages/market/balance/RechargeConfig'
import SeckillList from '@/pages/market/seckill/SeckillList'
import SeckillAdd from '@/pages/market/seckill/SeckillAdd'
import SeckillGoodsList from '@/pages/market/seckill/SeckillGoodsList'
import GoodsList from '@/pages/market/seckill/GoodsList'
import GoodsAdd from '@/pages/market/seckill/GoodsAdd'
import SeckillOrder from '@/pages/market/seckill/SeckillOrder'
import BenefitsGoodsList from '@/pages/market/newcomerBenefits/GoodsList'
import BenefitsGoodsAdd from '@/pages/market/newcomerBenefits/GoodsAdd'
import IntegralConfig from '@/pages/market/integralMall/Config'
import IntegralExtraCheckIn from '@/pages/market/integralMall/ExtraCheckIn'
import IntegralSpecial from '@/pages/market/integralMall/Special'
import IntegralMall from '@/pages/market/integralMall/Mall'
import IntegralMallGoodsAdd from '@/pages/market/integralMall/MallGoodsAdd'
import IntegralMallOrder from '@/pages/market/integralMall/Order'
import IntegralMallTask from '@/pages/market/integralMall/Task'
import IntegralMallTaskAdd from '@/pages/market/integralMall/TaskAdd'
import IntegralMallTaskTopic from '@/pages/market/integralMall/TaskTopic'
import IntegralMallTaskTopicAdd from '@/pages/market/integralMall/TaskTopicAdd'
import GiftPromotion from '@/pages/market/GiftPromotion/GiftPromotion'
import GiftPromotionAdd from '@/pages/market/GiftPromotion/GiftPromotionAdd'
import GiftManage from '@/pages/market/GiftPromotion/GiftManage'
import GiftManageAdd from '@/pages/market/GiftPromotion/GiftManageAdd'
import ActivityGoodsList from '@/pages/market/activity/GoodsList'
import ActivityGoodsAdd from '@/pages/market/activity/GoodsAdd'
import Coupon from '@/pages/market/coupon/Coupon'
import CouponAdd from '@/pages/market/coupon/Add'
import CouponGetRecord from '@/pages/market/coupon/GetRecord'
import CouponCenter from '@/pages/market/coupon/CouponCenter'
import CouponCenterAdd from '@/pages/market/coupon/CouponCenterAdd'
import CouponCenterManage from '@/pages/market/coupon/CouponCenterManage'
import SetMenu from '@/pages/market/setMenu/SetMenu'
import SetMenuAdd from '@/pages/market/setMenu/Add'
import Video from '@/pages/market/video/Video'
import VideoAdd from '@/pages/market/video/Add'
import WisdomLife from '@/pages/market/wisdomLife/WisdomLife'
import WisdomLifeCate from '@/pages/market/wisdomLife/Cate'
import WisdomLifeAdd from '@/pages/market/wisdomLife/Add'
import LxConfig from '@/pages/market/lx/Config'
import LxRecord from '@/pages/market/lx/Record'
import Discount from '@/pages/market/discount/Discount'
import DiscountAdd from '@/pages/market/discount/Add'
import DiscountGoodsList from '@/pages/market/discount/GoodsList'
import BargainActivity from '@/pages/market/bargainActivity/BargainActivity'
import BargainGoodsAdd from '@/pages/market/bargainActivity/BargainGoodsAdd'
import BargainOrder from '@/pages/market/bargainActivity/BargainOrder'
import PrizeDraw from '@/pages/market/prizeDraw/PrizeDraw'
import PrizeDrawRecord from '@/pages/market/prizeDraw/Record'
import PrizeDrawAdd from '@/pages/market/prizeDraw/PrizeDrawAdd'
import PrizeDrawManage from '@/pages/market/prizeDraw/PrizeDrawManage'
import PrizeDrawManageAdd from '@/pages/market/prizeDraw/PrizeDrawManageAdd'
import SmsConfig from '@/pages/market/sms/Config'
import AgentManagement from '@/pages/distributor/AgentManagement'
import AgentOrder from '@/pages/distributor/Order'
import AgentGoodsList from '@/pages/distributor/GoodsList'
import XyjBases from '@/pages/xyj/Bases'
import XyjBasesAdd from '@/pages/xyj/BasesAdd'
import BasesGoodsList from '@/pages/xyj/GoodsList'
import BasesGoodsAdd from '@/pages/xyj/GoodsAdd'
import BasesOrder from '@/pages/xyj/Order'
import XyjVideoCate from '@/pages/xyj/VideoCate'
import XyjVideo from '@/pages/xyj/Video'
import XyjVideoAdd from '@/pages/xyj/VideoAdd'
import ExperienceShop from '@/pages/experience/Shop'
import ExperienceShopAdd from '@/pages/experience/ShopAdd'
import InvoiceRecord from '@/pages/invoice/Record'
import InvoiceOrder from '@/pages/invoice/Order'
import ShopInfo from '@/pages/shop/InfoConfig'
import ShopList from '@/pages/shop/List'
import ShopAdd from '@/pages/shop/Add'
import ShopAdmin from '@/pages/shop/admin/List'
import ShopAdminAdd from '@/pages/shop/admin/Add'
import ShopRole from '@/pages/shop/role/Role'
import ShopRoleAdd from '@/pages/shop/role/RoleAdd'
import ShopBusinessQualification from '@/pages/shop/BusinessQualification'
import ShopPlatformList from '@/pages/goods/platform/List'
import ShopPlatformDetail from '@/pages/goods/platform/Detail'
import ShopGoodsList from '@/pages/goods/shop/List'
import ShopGoodsAdd from '@/pages/goods/shop/Add'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/',
      name: 'Layout',
      component: Layout,
      redirect:'/index',
      children:[{
        path: '/index',
        component: Index
      }, {
        path: '/banner',
        component: Banner
      }, {
        path: '/banner_add',
        component: Banner_add
      }, {
        path: '/popup',
        component: Popup
      }, {
        path: '/jg',
        component: Jg
      }, {
        path: '/jg_add',
        component: Jg_add
      }, {
        path: '/goods_cate',
        component: Goods_cate
      }, {
        path: '/goods_tag',
        component: Goods_tag
      }, {
        path: '/goods_comment',
        component: Goods_comment
      }, {
        path: '/goods_recommend_goods_list',
        component: RecommendGoodsList
      }, {
        path: '/goods_recommend_goods_add',
        component: RecommendGoodsAdd
      }, {
        path: '/goods_inspection_report_list',
        component: InspectionReportList
      }, {
        path: '/business_qualification',
        component: BusinessQualification
      }, {
        path: '/service_note',
        component: ServiceNote
      }, {
        path: '/privacy_policy',
        component: Privacy_policy
      }, {
        path: '/goods',
        component: Goods,
        meta: {
          keepAlive: true // 需要缓存
        }
      }, {
        path: '/goods_edit',
        component: GoodsEdit
      }, {
        path: '/user',
        component: User
      }, {
        path: '/user_detail',
        component: UserDetail
      }, {
        path: '/writeoff_record',
        component: WriteoffRecord
      }, {
        path: '/level',
        component: Level
      }, {
        path: '/level_add',
        component: LevelAdd
      }, {
        path: '/order',
        component: Order
      }, {
        path: '/tyzx_order',
        component: Order
      }, {
        path: '/after_sale',
        component: AfterSale
      }, {
        path: '/bases_refund',
        component: AfterSale
      }, {
        path: '/order_entry',
        component: OrderEntry
      }, {
        path: '/setting',
        component: Setting
      }, {
        path: '/base_info',
        component: JourneySetting
      }, {
        path: '/pickup',
        component: Pickup
      }, {
        path: '/pickup_add',
        component: PickupAdd
      }, {
        path: '/delivery',
        component: Delivery
      }, {
        path: '/role',
        component: Role
      }, {
        path: '/role_add',
        component: RoleAdd
      }, {
        path: '/manager',
        component: Manager
      }, {
        path: '/manager_add',
        component: ManagerAdd
      }, {
        path: '/finance',
        component: Finance
      }, {
        path: '/commission',
        component: Commission
      }, {
        path: '/commission_report_form',
        component: ReportForm
      }, {
        path: '/commission_member',
        component: CommissionMember
      }, {
        path: '/commission_order',
        component: CommissionOrder
      }, {
        path: '/lower_level',
        component: LowerLevel
      }, {
        path: '/promote_users',
        component: PromoteUsers
      }, {
        path: '/dl_apply',
        component: DlApply
      }, {
        path: '/branch_office',
        component: BranchOffice
      }, {
        path: '/agency_channel',
        component: AgencyChannel
      }, {
        path: '/gift_card_manage',
        component: GiftCardManage
      }, {
        path: '/gift_card_add',
        component: GiftCardAdd
      }, {
        path: '/stock_record',
        component: StockRecord
      }, {
        path: '/card_group',
        component: CardGroup
      }, {
        path: '/watch_card_group',
        component: WatchCardGroup
      }, {
        path: '/card_encryption_record',
        component: CardEncryptionRecord
      }, {
        path: '/gift_card_order',
        component: GiftCardOrder
      }, {
        path: '/group_goods',
        component: GroupGoods
      }, {
        path: '/group_goods_add',
        component: GroupGoodsAdd
      }, {
        path: '/group_list',
        component: GroupList
      }, {
        path: '/recharge_amount',
        component: RechargeAmount
      }, {
        path: '/recharge_record',
        component: RechargeRecord
      }, {
        path: '/recharge_config',
        component: RechargeConfig
      }, {
        path: '/seckill_list',
        component: SeckillList
      }, {
        path: '/seckill_add',
        component: SeckillAdd
      }, {
        path: '/seckill_goods_list',
        component: SeckillGoodsList
      }, {
        path: '/goods_list',
        component: GoodsList
      }, {
        path: '/goods_add',
        component: GoodsAdd
      }, {
        path: '/seckill_order',
        component: SeckillOrder
      }, {
        path: '/benefits_goods_list',
        component: BenefitsGoodsList
      }, {
        path: '/benefits_goods_add',
        component: BenefitsGoodsAdd
      }, {
        path: '/integral_config',
        component: IntegralConfig
      }, {
        path: '/integral_extra_checkIn',
        component: IntegralExtraCheckIn
      }, {
        path: '/integral_special',
        component: IntegralSpecial
      }, {
        path: '/integral_mall',
        component: IntegralMall
      }, {
        path: '/integral_mall_goods_add',
        component: IntegralMallGoodsAdd
      }, {
        path: '/integral_mall_order',
        component: IntegralMallOrder
      }, {
        path: '/integral_mall_task',
        component: IntegralMallTask
      }, {
        path: '/integral_mall_task_add',
        component: IntegralMallTaskAdd
      }, {
        path: '/integral_mall_task_topic',
        component: IntegralMallTaskTopic
      }, {
        path: '/integral_mall_task_topic_add',
        component: IntegralMallTaskTopicAdd
      }, {
        path: '/gift_promotion',
        component: GiftPromotion
      }, {
        path: '/gift_promotion_add',
        component: GiftPromotionAdd
      }, {
        path: '/gift_manage',
        component: GiftManage
      }, {
        path: '/gift_manage_add',
        component: GiftManageAdd
      }, {
        path: '/activity_goods_list',
        component: ActivityGoodsList
      }, {
        path: '/activity_goods_add',
        component: ActivityGoodsAdd
      }, {
        path: '/coupon',
        component: Coupon
      }, {
        path: '/coupon_add',
        component: CouponAdd
      }, {
        path: '/coupon_get_record',
        component: CouponGetRecord
      }, {
        path: '/coupon_center',
        component: CouponCenter
      }, {
        path: '/coupon_center_add',
        component: CouponCenterAdd
      }, {
        path: '/coupon_center_manage',
        component: CouponCenterManage
      }, {
        path: '/set_menu',
        component: SetMenu
      }, {
        path: '/set_menu_add',
        component: SetMenuAdd
      }, {
        path: '/video',
        component: Video
      }, {
        path: '/video_add',
        component: VideoAdd
      }, {
        path: '/wisdom_life_cate',
        component: WisdomLifeCate
      }, {
        path: '/wisdom_life',
        component: WisdomLife
      }, {
        path: '/wisdom_life_add',
        component: WisdomLifeAdd
      }, {
        path: '/lx_config',
        component: LxConfig
      }, {
        path: '/lx_record',
        component: LxRecord
      }, {
        path: '/discount',
        component: Discount
      }, {
        path: '/discount_add',
        component: DiscountAdd
      }, {
        path: '/discount_goods_list',
        component: DiscountGoodsList
      }, {
        path: '/bargain_activity',
        component: BargainActivity
      }, {
        path: '/bargain_goods_add',
        component: BargainGoodsAdd
      }, {
        path: '/bargain_order',
        component: BargainOrder
      }, {
        path: '/prize_draw',
        component: PrizeDraw
      }, {
        path: '/prize_draw_record',
        component: PrizeDrawRecord
      }, {
        path: '/prize_draw_add',
        component: PrizeDrawAdd
      }, {
        path: '/prize_draw_manage',
        component: PrizeDrawManage
      }, {
        path: '/prize_draw_manage_add',
        component: PrizeDrawManageAdd
      }, {
        path: '/agent_management',
        component: AgentManagement
      }, {
        path: '/agent_order',
        component: AgentOrder
      }, {
        path: '/agent_goods_list',
        component: AgentGoodsList
      }, {
        path: '/xyj_bases',
        component: XyjBases
      }, {
        path: '/xyj_bases_add',
        component: XyjBasesAdd
      }, {
        path: '/bases_goods_list',
        component: BasesGoodsList
      }, {
        path: '/bases_goods_add',
        component: BasesGoodsAdd
      }, {
        path: '/bases_order',
        component: BasesOrder
      }, {
        path: '/xyj_video_cate',
        component: XyjVideoCate
      }, {
        path: '/xyj_video',
        component: XyjVideo
      }, {
        path: '/xyj_video_add',
        component: XyjVideoAdd
      }, {
        path: '/sms_config',
        component: SmsConfig
      }, {
        path: '/shop',
        component: ExperienceShop
      }, {
        path: '/shop_add',
        component: ExperienceShopAdd
      }, {
        path: '/invoice_record',
        component: InvoiceRecord
      }, {
        path: '/invoice_order',
        component: InvoiceOrder
      }, {
        path: '/shop_info',
        component: ShopInfo
      }, {
        path: '/shop_list',
        component: ShopList
      }, {
        path: '/shop_list_add',
        component: ShopAdd
      }, {
        path: '/shop_admin',
        component: ShopAdmin
      }, {
        path: '/shop_admin_add',
        component: ShopAdminAdd
      }, {
        path: '/shop_role',
        component: ShopRole
      }, {
        path: '/shop_role_add',
        component: ShopRoleAdd
      }, {
        path: '/shop_business_qualification',
        component: ShopBusinessQualification
      }, {
        path: '/shop_platform_list',
        component: ShopPlatformList
      }, {
        path: '/shop_platform_detail',
        component: ShopPlatformDetail
      }, {
        path: '/shop_goods_list',
        component: ShopGoodsList
      }, {
        path: '/shop_goods_add',
        component: ShopGoodsAdd
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js